import React, { useContext } from 'react'
import "./PaymentHistory.css";
import { AuthContext } from '../../../context/AuthContext';
import toast from 'react-hot-toast';
import { NavLink, useNavigate } from 'react-router-dom';
function PaymentHistory() {
  const navigate = useNavigate();
  const {
    userId,
    isSubscribed,
    setIsSubScribed,
    hasUsedFreeTrial,
    setHasUsedFreeTrial,
    freeTrailEndsIn,
    setFreeTrailEndsIn,
    paymentDate,
    setPaymentDate,
    subScriptionEndDate,
    setSubscriptionEndDate,
    plan,
    setPlan,
    subScriptionAmount,
    setSubScriptionAmount,
    paymentMethod, setPaymentMethod,
    paymentStatus, setPaymentStatus,
    planStatus, setPlanStatus,
    subScriptionId, setSubScriptionId
  } = useContext(AuthContext);
  const accessToken = localStorage.getItem("token");
  const handleCancelSubscription = async () => {
    const cancelSubscriptionPromise = fetch(
      `${process.env.REACT_APP_BACKEND_URL}/cancel_subscription/${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`, 
        },
      }
    );

    toast
      .promise(
        cancelSubscriptionPromise.then(async (res) => {
          const data = await res.json();
          console.log(data);

          if (!res.ok) {
            throw new Error(data.message || "Failed to cancel subscription");
          }
          return data; // Return the response data
        }),
        {
          loading: "Canceling subscription...",
          success: "Subscription successfully canceled!",
          error: (err) => err.message || "Failed to cancel subscription.",
        }
      )
      .then((data) => {
        // Handle success case
        console.log("Cancellation successful:", data);
        // Perform any additional actions, such as updating the UI
      })
      .catch((error) => {
        // Handle error case
        console.error("Error canceling subscription:", error);
      });
  };



  return (
    <>
      <div className='px-4 lg:px-20 xl:px-20 2xl:px-20'>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <div className=" bg-white dark:bg-[#222a32] shadow-md border-l-4 border-[#0CC8E8] p-4 flex flex-col justify-between">
            <div className="text-gray-500 dark:text-white text-sm mb-2">Current {plan} bill</div>
            <div className="text-2xl  dark:text-white ">${subScriptionAmount}</div>
            {
              (plan === "monthly" || plan === "basic")  && 
              <NavLink
                to={`${plan === 'monthly' ? "/pricing?plan=annual":"/pricing?plan=monthly"}`}
                className="flex items-center text-[#0CC8E8] text-sm mt-2 group hover:underline"
              >
                Switch to {plan === 'monthly' ? "Annual" : "Monthly"} billing
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 ml-1 transform group-hover:translate-x-2 group-hover:scale-125 transition-transform duration-300 ease-out"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </NavLink>
            }
          </div>

          <div className=" bg-white dark:bg-[#222a32] shadow-md border-l-4 border-[#58dbc8] p-4">
            <div className="text-gray-500 dark:text-white text-sm mb-2">Next payment due</div>
            <div className=" dark:text-white text-[16px]">{subScriptionEndDate === "" ? "No Active Plan":subScriptionEndDate}</div>
          </div>

          <div className=" bg-white dark:bg-[#222a32] shadow-md border-l-4 border-[#2DEEAA] p-4">
            <div className="text-gray-500 dark:text-white text-sm mb-2">Current plan</div>
            <div className="text-2xl font-bold dark:text-white ">{plan}</div>
            {
              plan !== "annual" &&
              <NavLink
                to={`${plan === "basic" ? "/pricing?plan=monthly" : "/pricing?plan=annual"}`}
                className="flex items-center text-[#2DEEAA] text-sm mt-2 group hover:underline"
              >
                Upgrade plan
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 ml-1 transform group-hover:translate-x-2 group-hover:scale-125 transition-transform duration-300 ease-out"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </NavLink>
            }
          </div>
        </div>
        <div className="bg-white dark:bg-[#222a32] shadow-md mt-10" style={{ boxShadow: "0px 4px 20px 5px #909090" }}>
          <div className="flex justify-between items-center p-4 border-b">
            <h2 className="font-semibold dark:text-white">Payment Methods</h2>
          </div>
          <div className="p-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <i className="fab fa-cc-visa text-blue-500 text-3xl"></i>
                <div className="ml-4">
                  <div className="text-gray-700 text-sm dark:text-white">Visa ending in 1234</div>
                  <div className="text-gray-500 text-xs dark:text-white">Expires 04/2024</div>
                </div>
              </div>
              <div>
                <span className="bg-gray-200 text-gray-600 px-2 py-1 rounded">Default</span>
                <NavLink to="/update-card" className="text-blue-500 ml-4 hover:underline">Edit</NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-[#222a32] shadow-md mt-10 " style={{ boxShadow: "0px 4px 20px 5px #909090" }}>
          <div className="flex justify-between items-center p-4 border-b">
            <p className="ml-4 font-semibold dark:text-white">{plan === 'monthly' || plan === 'annual' ? "End":""} subscription</p>
            {plan !== "basic" && <button className="bg-red-500 text-white px-4 py-2 rounded" onClick={handleCancelSubscription}>Cancel Your Subscription</button>}
          </div>
          <div className="p-4">
            <div className="flex justify-between items-center">
              <div className="flex items-center">
                <i className="fab fa-cc-visa text-blue-500 text-3xl"></i>
                <div className="ml-4 text-[15px] md:text-[15px] lg:text-lg xl:text-lg 2xl:text-lg" >
                  <p className="mb-5 dark:text-white">Here’s what’s unlocked for you in Unlimited:</p>
                  <ul className='list-disc ml-4 dark:text-white'>
                    <li>
                      <p className="mb-2 "><span className="font-bold">Unlimited Access to All AI Therapy Features:</span> Your Speech Guardian, available
                        24/7, offering personalized support and guidance.</p>
                    </li>
                    <li>
                      <p className="mb-2"><span className="font-bold">Personalized Insights and Tailored Progress Tracking:</span> Track your growth with
                        advanced insights and tools designed just for you.</p>
                    </li>
                    <li>
                      <p className="mb-2 "><span className="font-bold">Interactive Therapy Games: </span> Fun, engaging exercises to help you support your
                        growth and stay motivated.</p>
                    </li>
                    <li>
                      <p className="mb-2 "><span className="font-bold">Exclusive Premium Features: </span> Priority support, AI-guided exercises, and more to
                        accelerate your progress.</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-[#222a32] shadow-md mt-10">
          <div className="p-4 border-b">
            <h2 className="font-semibold dark:text-white">Billing History</h2>
          </div>
          <div className="p-4">
            <table className="table-auto w-full text-left dark:text-white">
              <thead>
                <tr>
                  <th className="border-b-2 py-2">Transaction ID</th>
                  <th className="border-b-2 py-2">Date</th>
                  <th className="border-b-2 py-2">Amount</th>
                  <th className="border-b-2 py-2">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="py-2">#39201</td>
                  <td className="py-2">06/15/2021</td>
                  <td className="py-2">$29.99</td>
                  <td className="py-2"><span className="bg-gray-200 text-gray-600 px-2 py-1 rounded">Pending</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
     
      


    </>
  )
}

export default PaymentHistory;
